import * as React from 'react';

import { SearchBox } from '@fluentui/react/lib/SearchBox';
import { ITheme } from '@fluentui/react/lib/Styling';

import { dataUniqueId } from '@1js/acui-common';
import { iconNameToIconProps } from '@1js/acui-icons';
import { AppThemeConsumer } from '@1js/acui-theme';

import { AppSearchBoxProps } from './AppSearchBox.Props';
import { getAppSearchBoxStyles } from './AppSearchBox.styles';

export const AppSearchBox: React.FunctionComponent<AppSearchBoxProps> = props => {
  const {
    placeholder,
    styles,
    autoComplete,
    componentRef,
    clearButtonProps,
    label,
    icon,
    iconColor,
    ariaControls,
    dataAutomationType,
  } = props;

  return (
    <AppThemeConsumer>
      {(theme: ITheme) => (
        <SearchBox
          {...props}
          type={'search'}
          data-automation-type={dataAutomationType || 'AppSearchBox'}
          data-unique-id={dataUniqueId(props)}
          placeholder={placeholder || label}
          styles={getAppSearchBoxStyles(theme, !!icon, styles)}
          iconProps={iconNameToIconProps(icon, iconColor)}
          autoComplete={autoComplete}
          componentRef={componentRef}
          clearButtonProps={clearButtonProps}
          aria-controls={ariaControls}
        />
      )}
    </AppThemeConsumer>
  );
};
